import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FullWidthLink = styled(Link)`
    width: 100%;
`;

export default FullWidthLink;
